import AnimatedHero from '@/components/AnimatedHero'
import ContactForm from '@/components/ContactForm'
import FlexibleContent from '@/components/FlexibleContent'
import Main from '@/components/Main'
import Posts from '@/components/Posts'
import SEO from '@/components/SEO'
import { FlexibleContentFragment } from '@/fragments/FlexibleContent'
import { GravityFormsFragment } from '@/fragments/GravityForms'
import { PostsFragment } from '@/fragments/Posts'
import styles from '@/styles/pages/_Home.module.scss'
import { gql } from '@apollo/client'
export default function Component(props) {
  if (props?.loading) {
    return null
  }

  const flexibleContent = props?.data?.pages?.nodes?.[0]?.template?.flexibleContent?.flexibleContentFields ?? []
  const gravityforms = props?.data?.gfForms?.nodes || []
  const contactID = 1
  const form = gravityforms.find((node) => node.databaseId === contactID)
  const { title, metaDesc } = props?.data?.pages?.nodes?.[0]?.seo || {}

  return (
    <>
      <SEO title={title} description={metaDesc} />

      <AnimatedHero />

      <Main className={styles.home} id="main-home">
        <FlexibleContent content={flexibleContent} />

        <div data-aos="fade-up">
          <Posts posts={props?.data?.posts?.nodes} id="posts-list" />
        </div>

        {form && <ContactForm form={form} />}
      </Main>
    </>
  )
}

Component.query = gql`
  ${GravityFormsFragment}
  ${PostsFragment}
  ${FlexibleContentFragment}
  query GetPageData {
    posts(first: 12) {
      nodes {
        ...PostsFeedItemFragment
      }
    }
    pages(where: { id: 346 }) {
      nodes {
        ...FlexibleContentFragment
        seo {
          metaDesc
          title
        }
      }
    }
    gfForms {
      nodes {
        ...GravityFormsFragment
      }
    }
  }
`
